
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../../controlador';
    import lista from './estadisticas-situacion-empresa-lista.vue';
    import actual from './estadisticas-situacion-empresa-actual.vue';
    import { Empresa } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            actual,
            lista,
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Model; }

        public Empresa: Empresa = Empresa.CASAJARSE;

        public MenuAbierto: boolean = false;
        public Buscador: string = '';
        public Estado: string = '';
        public SubModo: string = '';
        public Modo: string = '';

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {
            this.Buscador = this.Controlador.Vista.Buscador;
            this.Estado = this.Controlador.Vista.Estado;
            this.Modo = this.Controlador.Vista.Modo;
            this.Eventos.push( this.Controlador.Vista.onBuscador.subscribe( () => this.Buscador = this.Controlador.Vista.Buscador ) );
            this.Eventos.push( this.Controlador.Vista.onEstado.subscribe( () => this.Estado = this.Controlador.Vista.Estado ) );
            this.Eventos.push( this.Controlador.Vista.onModo.subscribe( () => this.Modo = this.Controlador.Vista.Modo ) );
            this.Eventos.push( this.Controlador.Vista.onSubModo.subscribe( () => this.SubModo = this.Controlador.Vista.SubModo ) );
            this.Eventos.push( this.Controlador.Vista.onMenuAbierto.subscribe( () => this.MenuAbierto = this.Controlador.Vista.MenuAbierto ) );

            if ( this.Controlador.EmpresaSeleccionado )
                this.Empresa = this.Controlador.EmpresaSeleccionado;
        }


    }
